/* eslint-disable no-nested-ternary */
import {
  ApplicationExistsModalController,
  BreederOverviewModalController,
  BuyerChecklistModalController,
  ChangePasswordModalController,
  ApplicationMessageModalController,
  AuthModalController,
  CookiesBannerController,
  ImageLightboxController,
  LoadingOverlayController,
  MtFreeApplicationsController,
  MtUpdateLitterModalController,
  NewsletterModalController,
  ResetPasswordModalController,
  SocialShareModalController,
  UseSocialLoginlModalController,
  WhatsappModalController,
  VetAdviceModalController,
  MtBreederStorePartnershipModalController,
} from '@application/components/controllers';
import {
  APPLICATION_EXISTS_MODAL_ROUTES,
  APPLICATION_MESSAGE_ROUTES,
  AUTH_MODAL_ROUTES,
  BREEDER_OVERVIEW_MODAL_ROUTES,
  BUYER_CHECKLIST_MODAL_ROUTES,
  CHANGE_PASSWORD_MODAL_ROUTES,
  FREE_APPLICATIONS_MODAL_ROUTES,
  LIGHTBOX_ROUTES,
  LITTER_UPDATE_MODAL_ROUTES,
  MT_BREEDER_STORE_PARTNERSHIP_MODAL_ROUTES,
  RESET_PASSWORD_MODAL_ROUTES,
  SOCIAL_LOGIN_MODAL_ROUTES,
  SOCIAL_SHARE_MODAL_ROUTES,
  VET_ADVICE_ROUTES,
  WHATS_APP_MODAL_ROUTES,
} from '@application/constants';
// import { startSessionReplayWithAccount } from '@application/datadog';
import { useRouter } from '@application/utils';
import { useMemo } from 'react';

export const Modals = () => {
  const { infoFromCurrentPath } = useRouter();

  const injectVetAdviceModal = useMemo(() => {
    return VET_ADVICE_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectAppMessageModal = useMemo(() => {
    return APPLICATION_MESSAGE_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectLightbox = useMemo(() => {
    return LIGHTBOX_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectFreeApplicationsModal = useMemo(() => {
    return FREE_APPLICATIONS_MODAL_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectWhatsappModal = useMemo(() => {
    return WHATS_APP_MODAL_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectLitterUpdateModal = useMemo(() => {
    return LITTER_UPDATE_MODAL_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectMtBreederStorePartnershipModal = useMemo(() => {
    return MT_BREEDER_STORE_PARTNERSHIP_MODAL_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectResetPasswordModal = useMemo(() => {
    return RESET_PASSWORD_MODAL_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectSocialShareModal = useMemo(() => {
    return SOCIAL_SHARE_MODAL_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectAuthModal = useMemo(() => {
    return AUTH_MODAL_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectSocialLoginModal = useMemo(() => {
    return SOCIAL_LOGIN_MODAL_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectChangePasswordModal = useMemo(() => {
    return CHANGE_PASSWORD_MODAL_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectBuyerChecklistModal = useMemo(() => {
    return BUYER_CHECKLIST_MODAL_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectApplicationExistsModal = useMemo(() => {
    return APPLICATION_EXISTS_MODAL_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const injectBreederOverviewModal = useMemo(() => {
    return BREEDER_OVERVIEW_MODAL_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  return (
    <>
      <LoadingOverlayController />
      <NewsletterModalController />
      <CookiesBannerController />
      {injectVetAdviceModal ? <VetAdviceModalController /> : null}
      {injectAppMessageModal ? <ApplicationMessageModalController /> : null}
      {injectLightbox ? <ImageLightboxController /> : null}
      {injectFreeApplicationsModal ? <MtFreeApplicationsController /> : null}
      {injectWhatsappModal ? <WhatsappModalController /> : null}
      {injectLitterUpdateModal ? <MtUpdateLitterModalController /> : null}
      {injectMtBreederStorePartnershipModal ? <MtBreederStorePartnershipModalController /> : null}
      {injectResetPasswordModal ? <ResetPasswordModalController /> : null}
      {injectSocialShareModal ? <SocialShareModalController /> : null}
      {injectAuthModal ? <AuthModalController /> : null}
      {injectSocialLoginModal ? <UseSocialLoginlModalController /> : null}
      {injectChangePasswordModal ? <ChangePasswordModalController /> : null}
      {injectBuyerChecklistModal ? <BuyerChecklistModalController /> : null}
      {injectApplicationExistsModal ? <ApplicationExistsModalController /> : null}
      {injectBreederOverviewModal ? <BreederOverviewModalController /> : null}
    </>
  );
};
